import React from 'react'

interface CanvasTextIconProps {
  size?: number
  className?: string
}

/**
 * Das Icon des **Text**-Werkzeugs in der Werkzeug-Pille ("Text platzieren")
 * — Figma `btn Canvas Toolbar Text` 5153:96153, das Glyph `text-tool 1`
 * (Node `5153:96143`): ein blasser Rahmen, vier Eckpunkte, ein T.
 *
 * Blaues Paar — Füllung `#EBF3FF`, Kontur `#4585EC` — analog zum gelben
 * `CanvasNoteIcon`, zum cyanen `CanvasMemoIcon` und zum violetten
 * `CanvasAreaIcon`: Die Farbe kennzeichnet den Werkzeugtyp, nicht einen
 * UI-Zustand, deshalb kein Theme-Token.
 *
 * Die Pfade stehen unverändert so, wie Figma sie exportiert; Default und
 * Hover tragen dasselbe Glyph — der Hover-Zustand ist im Code der
 * Hintergrund der Pille, nicht ein zweites Icon.
 *
 * Das T steht in einer eigenen Gruppe: Es hüpft beim Überfahren (#315, `_toolbarIconMotion.scss`).
 */
export const CanvasTextIcon: React.FC<CanvasTextIconProps> = ({ size = 24, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['canvas-text-icon', className].filter(Boolean).join(' ')}
  >
    <path d="M6.5 6L7.5 5H17.5L18 6.5H19V17L18 18L17 19H6.5L6 17.5L5 17V7L6.5 6Z" fill="#EBF3FF" />
    <path d="M6.50003 4.66675H17.5" stroke="#4585EC" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M6.50003 19.3333H17.5" stroke="#4585EC" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M19.3334 6.5V17.5" stroke="#4585EC" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M4.66672 6.5V17.5" stroke="#4585EC" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M6.50001 3.79575C6.50001 3.26418 6.06908 2.83325 5.53751 2.83325H3.79584C3.26427 2.83325 2.83334 3.26418 2.83334 3.79575V5.53742C2.83334 6.06899 3.26427 6.49992 3.79584 6.49992H5.53751C6.06908 6.49992 6.50001 6.06899 6.50001 5.53742V3.79575Z" stroke="#4585EC" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M6.50007 18.4625C6.50007 17.9309 6.06915 17.5 5.53757 17.5H3.79591C3.26433 17.5 2.8334 17.9309 2.8334 18.4625V20.2042C2.8334 20.7357 3.26433 21.1667 3.7959 21.1667H5.53757C6.06914 21.1667 6.50007 20.7357 6.50007 20.2042V18.4625Z" stroke="#4585EC" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M21.1667 3.79575C21.1667 3.26418 20.7358 2.83325 20.2042 2.83325H18.4625C17.931 2.83325 17.5 3.26418 17.5 3.79575V5.53742C17.5 6.06899 17.931 6.49992 18.4625 6.49992H20.2042C20.7358 6.49992 21.1667 6.06899 21.1667 5.53742V3.79575Z" stroke="#4585EC" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M21.1667 18.4625C21.1667 17.9309 20.7358 17.5 20.2042 17.5H18.4625C17.931 17.5 17.5 17.9309 17.5 18.4625V20.2042C17.5 20.7357 17.931 21.1667 18.4625 21.1667H20.2042C20.7358 21.1667 21.1667 20.7357 21.1667 20.2042V18.4625Z" stroke="#4585EC" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" />
    <g className="canvas-text-icon__letter">
      <path d="M12 15.6667V9.25" stroke="#4585EC" strokeWidth="1.6" strokeMiterlimit="10" strokeLinecap="round" />
      <path d="M9.25003 9.25H14.75" stroke="#4585EC" strokeWidth="1.6" strokeMiterlimit="10" strokeLinecap="round" />
    </g>
  </svg>
)
